<template>
    <body class="white-bg">
        <div>
            <div id="form" class="ibox page-full">
                <div class="r-header">SK텔레콤 노동조합 입후보 현황 및 등록</div>
                <div>
                    <div class="progress">
                        <div role="progressbar" aria-valuenow="35" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-warning" style="width: 0%;">0%</div>
                    </div>
                </div>
                <div class="r-box no-borders m-0">
                    <div id="question_0" style="display: block;">
                        <div class="r-ques">
                            <div align="center" style="margin : 0px 0px 0px 0px; padding: 2px;">
                                <b><u>{{title}} 입후보자 등록양식</u></b>
                            </div>                            
                        </div>
                    </div>
                    <div>
                        <table>
                            <tr>
                                <td><b>구분</b></td>
                                <td><b>성명</b></td>
                                <td><b>사번</b></td>
                                <td><b>소속</b></td>
                            </tr>
                            <tr>
                                <td>{{clazz}}</td>
                                <td>{{name}}</td>
                                <td>{{employeeNumber}}</td>
                                <td>{{team}}</td>
                            </tr>
                            <tr v-for="p in partners" v-bind:key="p">
                              <td>{{p.clazz}}</td>
                              <td>{{p.name}}</td>
                              <td>{{p.employeeNumber}}</td>
                              <td>{{p.team}}</td>
                            </tr>
                            <tr>
                                <td colspan="4"><b>입후보 소견서(250자 이내)</b></td>
                            </tr>
                            <tr>
                                <td colspan="4" style="padding: 10px">
                                    {{opinion}}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><b>추 천 인</b></td>
                            </tr>
                            <tr>
                                <td><b>번호</b></td>
                                <td><b>사번</b></td>
                                <td><b>성명</b></td>
                                <td><b>추천일시</b></td>
                            </tr>
                            
                            <tr v-for="(item, index) in recommendList" v-bind:key="item">
                                <td>{{index+1}}</td>
                                <td>{{item.employeeNumber}}</td>
                                <td>{{item.name}}</td>
                                <td>{{item.recommendedAt}}</td>
                            </tr>

                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            
                            <tr>
                                <td colspan="4" style="padding: 10px">
                                    상기인은 SK텔레콤노동조합 {{title}} {{district}}선거구에 입후보하고자 본 등록서류를 제출하며, 선거관리규정과 선거관리지침 및 절차를 준수할 것을 서약합니다.
                                    <br/><br/>
                                    {{submittedAt}}
                                    <br/><br/>
                                    <span>{{clazz}} 입후보자 {{name}}</span>
                                    <span v-for="p in partners" v-bind:key="p"><br/>{{p.clazz}} 입후보자 {{p.name}}</span>
                                </td>
                            </tr>
                        </table>

                        <div align="center" style="margin : 20px 0px 10px 0px; padding: 2px;">
                            <h3>SK텔레콤 노동조합 중앙선거관리위원회 귀중</h3>
                        </div>                            

                    </div>
                    <div id="pageEnd" class="r-text-center mt-5 mb-2">
                        <span v-if="!submitted && !enoughRecommended">{{district}} 선거구 입후보 등록을 위해<br/>총 {{minimumRecommendCount}}명의 추천이 필요합니다.<br/></span>
                        <button v-if="!submitted" :disabled="!enoughRecommended" id="nextPage" class="btn btn-success r-btn-width" @click="next">제출하기</button>
                        <span v-if="submitted">{{district}} 선거구 입후보 등록이 완료되었습니다.</span>
                    </div>
                </div>
            </div>
            <div class="r-footer"></div>
        </div>
    </body>
</template>

<script>
import moment from 'moment'
import Service from '@/services/RecommendService'

export default {
  name: 'home',
  props: {
    msg: String
  },
  data() {
    return {
        hash: null,
        title: null,
        clazz: null,

        name: null,
        employeeNumber: null,
        team: null,
        rrn: null,

        partners: null,

        opinion: null,
        recommendList: null,
        district: null,

        minimumRecommendCount: null,
        enoughRecommended: false,
        submitted: false,
        submittedAt: null,
        registerHash: null,
    }
  },
  mounted() {
      window.scrollTo(0, 0)
      this.hash = this.$route.params.hash

      Service.getMyRecommendations(
          (data_ok) => {
              if (!data_ok.success) {
                  alert(data_ok.message)
                  return
              }

              const candidate = data_ok.data.candidate
              const topic = data_ok.data.topic
              const summary = data_ok.data.summary

              this.title = topic.title
              this.clazz = topic.clazz
              this.registerHash = candidate.registerHash

              this.name = candidate.name
              this.employeeNumber = candidate.employeeNumber
              this.team = candidate.team

              this.partners = candidate.partners

              this.opinion = candidate.candidacyOpinion
              this.district = candidate.electionWard
              this.minimumRecommendCount = summary.requiredRecommendations
              this.recommendList = data_ok.data.recommendations.map(rec => ({
                  employeeNumber: rec.recommenderEmployeeNumber,
                  name: rec.recommenderName,
                  recommendedAt: moment(rec.recommendedAt).format('YYYY. MM. DD HH:mm')
              }))
              this.enoughRecommended = summary.recommendationsMet

              if (candidate.submittedAt) {
                  this.submittedAt = moment(candidate.submittedAt).format('YYYY. MM. DD')
                  this.submitted = true
              } else {
                  //제출 이전. 오늘날짜 표기
                  this.submittedAt = moment().format('YYYY. MM. DD')
              }
          }
      )
  },
  methods: {
      next() {
          Service.submitCandidate(
              this.registerHash,
              (data_ok) => {
                  if (!data_ok.success) {
                      alert(data_ok.message)
                      return
                  }

                  alert("입후보 등록이 완료되었습니다.")
                  this.submitted = true
                  this.submittedAt = moment().format('YYYY. MM. DD')
              }
          )
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    table {
        width: 100%;
    }
    table, td {
        border: 1px solid black;
        font-size: 10px;
    }
</style>
